module.exports = __webpack_public_path__ + "img/icon_gerenciamento_de_comunicacoes_hover.3821796a.png";